import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  HStack,
  Icon,
  Text
} from "@chakra-ui/react";
import { FaHistory } from "react-icons/fa";
import Logs from "../../../../../components/logs/Logs";

const HistoryModal = ({
  ticketID,
  state,
}) => {
  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={3}>
            <Icon as={FaHistory} color="green.500" />
            <Text>Aktivite Geçmişi</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Logs
            subjectType="tickets"
            subjectID={ticketID}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={state.onClose}>
            Kapat
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HistoryModal;